import {Cell, Column, Worksheet} from 'exceljs';

export const setColumnWidth = (cell: Partial<Cell>, width: number) => {
    const columnIndex = cell.col;

    if (columnIndex) {
        const worksheet = cell.worksheet as Worksheet;
        const column = worksheet.getColumn(columnIndex) as Partial<Column>;
        column.width = width;
    }
};
